import React from 'react'
import logo from '../assets/img/logo.png'
import { HorizontalStack, Image, Link, StickyFooter } from '@ztechapps/webui.util'
import { AppVersion, CopyrightNotice } from '@ztechapps/webui.page'
import { Col, Container, Row } from 'react-bootstrap'
import { appSettings } from '../config/app-settings'

export const LoginOverview = ({ children }) => {
  return (
    <div style={{ marginTop: 150 }}>
      <Container>
        <Row>
          <Col>
            <div>
              <div className="row">
                <div className="col-md-12">
                  <Link href="/">
                    <Image url={logo} className="" />
                  </Link>
                </div>
                <div className="col-md-12">
                  <h2 className="fw-bold">{appSettings.AppFullName}</h2>
                  <small>Easy to use / rock solid support. </small>
                </div>
              </div>
              <div className="mt-5"></div>
              <ul>
                <li>
                  <a href="/" target="_blank" rel="noopener noreferrer">
                    <strong>Homepage</strong>
                  </a>
                </li>
                <li>
                  <a href="mailto:support@totalmilk.com" target="_blank" rel="noopener noreferrer">
                    <strong>Support</strong>
                  </a>
                </li>
              </ul>
              <p>By signing up for and by signing in to this service you accept our:</p>
              <ul>
                <li>
                  <a href="/privacy-policy.html" target="_blank" rel="noopener noreferrer">
                    <strong>Privacy statement</strong>
                  </a>
                </li>
                <li>
                  <a href="/terms-and-condition.html" target="_blank" rel="noopener noreferrer">
                    <strong>Terms of use</strong>
                  </a>
                </li>
              </ul>
            </div>
          </Col>
          <Col>{children}</Col>
        </Row>
      </Container>

      <StickyFooter>
        <Container>
          <hr />
          <div>
            <HorizontalStack className="justify-content-between ">
              <CopyrightNotice companyName={appSettings.CompanyName} />
              <AppVersion />
            </HorizontalStack>
          </div>
        </Container>
      </StickyFooter>
    </div>
  )
}
